export default __webpack_public_path__ + "static/media/s5.c6a2e685.png";